export default __webpack_public_path__ + "static/media/passed.c6b20744.svg";